export const MARKETING_TAGS = {
  GOTO: 'GOTO',
  PRCD: 'PRCD',
  NEWV: 'NEWV',
}
